<template>
  <ElTooltip
    class="mini-add-button-with-help"
    placement="top"
    :content="content"
    :disabled="!disabled"
  >
    <div class="mini-add-button-with-help__button-container">
      <ElButton
        size="mini"
        native-type="button"
        type="primary"
        icon="el-icon-plus"
        class="mini-add-button-with-help__button"
        :class="{ 'mini-add-button-with-help__button--plain': plain }"
        :disabled="disabled"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <slot />
      </ElButton>
    </div>
  </ElTooltip>
</template>

<script>
export default {
  name: 'MiniAddButtonWithHelp',
  inheritAttrs: false,
  props: {
    content: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.mini-add-button-with-help {
  &__button-container {
    display: inline-block;
  }

  &__button {
    &--plain {
      background-color: transparent;
      color: $green-pear;
    }
  }
}
</style>
